import { render, staticRenderFns } from "./VerifyTokenResetPassword.vue?vue&type=template&id=294e8252&"
import script from "./VerifyTokenResetPassword.vue?vue&type=script&lang=js&"
export * from "./VerifyTokenResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./VerifyTokenResetPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports